import {
    Card,
    CardBody,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { Action } from "redux";
import { useDispatch, useSelector } from "react-redux";
import QuickForm from "Components/Common/FormBuilder/QuickForm";
import { useEffect, useState } from "react";
import SimpleBar from "simplebar-react";
import { withTranslation } from "react-i18next";
import { noteCreateRequest } from "store/notes/action";
import { callsMetadataGetRequest } from "store/calls/action";
import { ApplicationState } from "store";
import Loader from '../../Tasks/innerComponent/FormLoader'
import AddTaskEntry from '../../Tasks/innerComponent/AddEntryModal';
import { taskCreateRequest } from "store/tasks/action";

const AddEntry = ({ props, show, onCloseClick, dataFields, setTriggerApi, createAction, studentId, applicationId, isSelectionCall, userProfile, parentModel }: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const metaLoading = useSelector((state: ApplicationState) => state.tasks.metaLoading);
    const [disabled, setDisabled] = useState<any>(false)
    const [callDescriptionNote, setCallDescriptionNote] = useState<any>();
    const [tasksModals, setTasksModals] = useState<boolean>(false);
    const [formvalues, setFormvalues] = useState();

    useEffect(() => {
        let filterObject = { PageSize: 500 }
        dispatch(callsMetadataGetRequest("calls", filterObject))
    }, [])
    
    const OnAddEntry = (formValues: any) => {
        setDisabled(true);
    
        const data: any = {
            ...formValues,
            student: studentId,
            application: applicationId || null,
        };
    
        const handleSuccess = (body: any) => {
            const followUpRequired = formValues?.['follow_up_required'];
            if (followUpRequired) {
                handleAddNote();
                setTasksModals(true); // ✅ trigger modal directly here
            } else {
                handleAddNote();
                setTriggerApi((prev: any) => !prev);
                onCloseClick();
            }
    
            setDisabled(false); // ✅ Always reset disabled at the end
        };
    
        const handleFailure = (body: any) => {
            setDisabled(false);
        };
    
        const parent_model = applicationId ? "applications" : "students";
        dispatch(createAction(data, handleSuccess, handleFailure, parent_model));
    };
    
  
    const handleAddNote = () => {
        const data =
        {
            student: studentId,
            application: applicationId ? applicationId : null,
            shortNote: "Others",
            parent: "",
            note: callDescriptionNote,
            assigned_by: userProfile?.id
        }
        const handleSuccess = (body: any): void => {
        };

        const handleError = (body: any): void => {
        };

        const parentModel = applicationId ? 'applications' : 'students';
        dispatch(noteCreateRequest(data, parentModel, handleSuccess, handleError));
    };
    
    return (
        <>
        <AddTaskEntry
                show={tasksModals}
                onCloseClick={() => setTasksModals(false)}
                setTriggerApi={null}
                props={props}
                createAction={taskCreateRequest}
                userProfile={userProfile}
                studentId={studentId}
                applicationId={applicationId}
                model={parentModel}
                closeMainModal={onCloseClick}
            />
            <Modal
            direction="end"
            isOpen={show}
            id="offcanvasExample"
            toggle={onCloseClick}
            backdrop={false}
        >

            <ModalHeader className="p-3 bg-primary-subtle" toggle={() => { onCloseClick(!show) }}>
                <span className="m-0 me-2">
                    {props.t("student.modals.add_new_entry")}
                </span>
            </ModalHeader>
            <ModalBody>
                <Card className="border-0" style={{ boxShadow: 'none' }}>
                    <CardBody className="border-0">
                        <SimpleBar style={{ maxHeight: 450 }}>
                            {metaLoading ? <Loader /> :
                            <div className="live-preview vstack gap-2">
                                <QuickForm dataFields={dataFields} btnAction={OnAddEntry} btn_text={'Log Call'} formfor="students" btndisabled={disabled} isSelectionCall={isSelectionCall} setCallDescriptionNote={setCallDescriptionNote} />
                            </div> 
                             }

                        </SimpleBar>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
            </>
        
    );
};

export default withTranslation()(AddEntry);

